import { ActivityEventDto } from '../../../shared/modules/activity/dtos/activity-event.dto';
import { AgentCategoryActivityEventHydration } from './agent-category-activity-event-hydration.dto';

/**
 * An agent category activity event with hydrated related records.
 */
export class AgentCategoryActivityEventDto extends ActivityEventDto {
  hydrated?: AgentCategoryActivityEventHydration;
}
